/* Drinkpod 2026 — theme JS (no dependencies) */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const money = (cents) => {
    const fmt = (window.DP && DP.moneyFormat) || '${{amount}}';
    const amt = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amt);
  };

  /* toast */
  let toastEl;
  function toast(html) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; document.body.appendChild(toastEl); }
    toastEl.innerHTML = html; toastEl.classList.add('on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(() => toastEl.classList.remove('on'), 3200);
  }

  /* cart count */
  function setCartCount(n) { $$('[data-cart-count]').forEach(el => { el.textContent = n; el.hidden = !n; }); }

  /* add to cart (single or set) */
  async function addItems(items) {
    const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
    if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.description || e.message || 'Could not add to cart'); }
    const c = await fetch('/cart.js').then(x => x.json());
    setCartCount(c.item_count);
    return c;
  }
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-add]');
    if (!b) return;
    e.preventDefault();
    const ids = b.dataset.add.split(',').map(s => s.trim()).filter(Boolean);
    const qty = parseInt(b.dataset.qty || '1', 10);
    b.disabled = true; const old = b.innerHTML; b.textContent = 'Adding…';
    try {
      const c = await addItems(ids.map(id => ({ id: Number(id), quantity: qty })));
      cd.render(c); cd.open();
    } catch (err) { toast(err.message); }
    b.disabled = false; b.innerHTML = old;
  });


  /* ---- cart drawer ----
     Opens on the header cart icon and after every add. Contents render from /cart.js so the
     panel is always current. The icon keeps its /cart href as the no-JS fallback. */
  const cd = {
    el: null, lines: null, empty: null, foot: null, sub: null, lastFocus: null,
    init() {
      this.el = $('[data-cart-drawer]'); if (!this.el) return;
      this.lines = $('[data-cart-lines]', this.el);
      this.empty = $('[data-cart-empty]', this.el);
      this.foot = $('[data-cart-foot]', this.el);
      this.sub = $('[data-cart-subtotal]', this.el);
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-cart-close]')) { e.preventDefault(); this.close(); return; }
        const open = e.target.closest('[data-cart-open]');
        if (open) { e.preventDefault(); this.open(); }
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.el.classList.contains('open')) this.close(); });
      this.el.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-cd-change]');
        if (!btn) return;
        e.preventDefault();
        const line = btn.dataset.cdLine, qty = btn.dataset.cdChange;
        this.el.classList.add('busy');
        try {
          const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Number(qty) }) });
          const c = await r.json();
          setCartCount(c.item_count); this.render(c);
        } catch (err) { toast('Could not update cart'); }
        this.el.classList.remove('busy');
      });
    },
    async open() {
      if (!this.el) { window.location.href = '/cart'; return; }
      this.lastFocus = document.activeElement;
      try { this.render(await fetch('/cart.js').then(x => x.json())); } catch (e) {}
      this.el.classList.add('open'); this.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cd-lock');
      const c = $('[data-cart-close]', this.el); if (c) c.focus();
    },
    close() {
      if (!this.el) return;
      this.el.classList.remove('open'); this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cd-lock');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    render(c) {
      if (!this.el) return;
      const has = c.item_count > 0;
      this.empty.hidden = has; this.foot.hidden = !has;
      this.sub.textContent = money(c.total_price);
      this.lines.innerHTML = !has ? '' : c.items.map((it, i) => {
        const line = i + 1;
        const img = it.image ? `<img src="${it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')}" alt="" loading="lazy">` : '';
        const variant = (it.variant_title && it.variant_title !== 'Default Title') ? `<div class="cvar">${it.variant_title}</div>` : '';
        return `<div class="cd-line">
          <a class="cim" href="${it.url}">${img}</a>
          <div class="cinfo">
            <a href="${it.url}">${it.product_title}</a>
            ${variant}
            <div class="crow">
              <span class="cd-qty">
                <button type="button" data-cd-change="${it.quantity - 1}" data-cd-line="${line}" aria-label="Decrease quantity">−</button>
                <span>${it.quantity}</span>
                <button type="button" data-cd-change="${it.quantity + 1}" data-cd-line="${line}" aria-label="Increase quantity">+</button>
              </span>
              <button type="button" class="cd-rm" data-cd-change="0" data-cd-line="${line}">Remove</button>
            </div>
          </div>
          <div class="camt">${money(it.final_line_price)}</div>
        </div>`;
      }).join('');
    },
  };
  cd.init();

  /* product form */
  $$('form[data-product-form]').forEach(form => {
    const data = JSON.parse($('[data-variants]', form).textContent);
    const idInput = $('input[name=id]', form);
    const priceEl = $('[data-price]', form);
    const wasEl = $('[data-was]', form);
    const btn = $('[data-submit]', form);
    const qtyInput = $('input[name=quantity]', form);
    /* selling plans: prices come from a server-rendered variant->plan map, so switching
       colourway reprices every plan without any client-side guesswork about discounts. */
    const planPrices = (() => { const el = $('[data-plan-prices]', form); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } })();
    const planInputs = $$('input[name=selling_plan]', form);
    const planFor = () => { const c = planInputs.find(i => i.checked); return c && c.value ? c.value : ''; };
    let currentVariant = null;
    function applyPlanPricing(v) {
      if (!planPrices || !v) return;
      const row = planPrices[String(v.id)] || {};
      const onetime = row.onetime != null ? row.onetime : v.price;
      const otEl = $('[data-po-onetime]', form);
      if (otEl) otEl.textContent = money(onetime);
      /* Cadences can carry different discounts, so each plan states its own and the header
         shows the range. Recomputed per variant: a colourway may discount differently. */
      let gmax = 0, gmin = 101;
      planInputs.forEach(i => {
        if (!i.value) return;
        const lbl = i.closest('label');
        const pe = lbl && $('[data-po-plan]', lbl);
        const price = row[i.value];
        const ok = price != null;
        if (pe) { if (ok) pe.textContent = money(price); pe.hidden = !ok; }
        const pc = (ok && onetime > 0 && price < onetime) ? Math.round((onetime - price) * 100 / onetime) : 0;
        if (ok && pc > 0) { if (pc > gmax) gmax = pc; if (pc < gmin) gmin = pc; }
        const pctEl = lbl && $('[data-po-pct]', lbl);
        if (pctEl) { pctEl.textContent = 'Save ' + pc + '%'; pctEl.hidden = !(ok && pc > 0); }
        i.disabled = !ok;
        if (lbl) lbl.classList.toggle('off', !ok);
        /* a plan the new variant can't be bought on must not stay selected */
        if (!ok && i.checked) { const ot = planInputs.find(x => !x.value); if (ot) ot.checked = true; }
      });
      const saveEl = $('[data-po-save]', form);
      if (saveEl) {
        saveEl.textContent = gmin < gmax ? 'Save up to ' + gmax + '%' : 'Save ' + gmax + '%';
        const chip = saveEl.closest('.chip');
        if (chip) chip.hidden = gmax <= 0;
      }
      const sel = planFor();
      const live = sel && row[sel] != null ? row[sel] : onetime;
      priceEl.textContent = money(live);
      const sticky = $('[data-sticky-price]', form);
      if (sticky) sticky.textContent = money(live);
      if (wasEl) {
        if (sel && row[sel] != null && onetime > row[sel]) { wasEl.textContent = money(onetime); wasEl.hidden = false; }
        else if (v.compare_at_price && v.compare_at_price > v.price) { wasEl.textContent = money(v.compare_at_price); wasEl.hidden = false; }
        else wasEl.hidden = true;
      }
    }
    function selected() { return $$('.opt', form).map(o => ($('input:checked', o) || {}).value); }
    const gal = $('[data-gallery]');
    function syncGal(v) {
      if (!gal) return;
      const main = $('.main img', gal);
      if (!main) return;
      const mid = v.featured_media && v.featured_media.id;
      const btn = mid ? $('.thumbs button[data-mid="' + mid + '"]', gal) : null;
      if (btn) {
        if (main.getAttribute('src') !== btn.dataset.src) { main.src = btn.dataset.src; main.alt = btn.dataset.alt || ''; }
        $$('.thumbs button', gal).forEach(x => x.classList.remove('on'));
        btn.classList.add('on');
      } else if (v.featured_image && v.featured_image.src) {
        const s = v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=1200';
        if (main.getAttribute('src') !== s) { main.src = s; main.alt = v.featured_image.alt || ''; }
      }
    }
    function update() {
      const opts = $$('.opt', form);
      const sel = selected();
      const v = opts.length ? data.find(v => v.options.every((o, i) => o === sel[i])) : (data.find(x => String(x.id) === idInput.value) || data[0]);
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      priceEl.textContent = money(v.price);
      if (wasEl) { if (v.compare_at_price && v.compare_at_price > v.price) { wasEl.textContent = money(v.compare_at_price); wasEl.hidden = false; } else wasEl.hidden = true; }
      btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.label : 'Sold out';
      syncGal(v);
      currentVariant = v;
      applyPlanPricing(v);
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    }
    form.addEventListener('change', e => {
      if (e.target.matches('.opt input')) update();
      else if (e.target.name === 'selling_plan') applyPlanPricing(currentVariant);
    });
    $$('.qty button', form).forEach(b => b.addEventListener('click', () => { const n = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + (b.dataset.dir === '+' ? 1 : -1)); qtyInput.value = n; }));
    form.addEventListener('submit', async e => {
      e.preventDefault(); btn.disabled = true; const old = btn.textContent; btn.textContent = 'Adding…';
      const item = { id: Number(idInput.value), quantity: parseInt(qtyInput.value, 10) || 1 };
      const chosenPlan = planFor();
      if (chosenPlan) item.selling_plan = Number(chosenPlan);
      try { const c = await addItems([item]); cd.render(c); cd.open(); }
      catch (err) { toast(err.message); }
      btn.disabled = false; btn.textContent = old;
    });
    update();
  });

  /* gallery */
  $$('[data-gallery]').forEach(g => {
    const main = $('.main img', g);
    $$('.thumbs button', g).forEach(b => b.addEventListener('click', () => { main.src = b.dataset.src; main.alt = b.dataset.alt || ''; $$('.thumbs button', g).forEach(x => x.classList.remove('on')); b.classList.add('on'); }));
  });

  /* mobile drawer */
  const drawer = $('[data-drawer]');
  function drawerSet(on) { if (!drawer) return; drawer.classList.toggle('open', on); drawer.setAttribute('aria-hidden', on ? 'false' : 'true'); document.body.classList.toggle('lock', on); }
  $$('[data-drawer-open]').forEach(b => b.addEventListener('click', () => drawerSet(true)));
  $$('[data-drawer-close]').forEach(b => b.addEventListener('click', () => drawerSet(false)));
  if (drawer) drawer.addEventListener('click', e => { if (e.target === drawer) drawerSet(false); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { drawerSet(false); const f = $('[data-facets]'); if (f) { f.classList.remove('open'); document.body.classList.remove('lock'); } } });

  /* facets drawer (mobile) */
  $$('[data-facets-toggle]').forEach(b => b.addEventListener('click', () => { const f = $('[data-facets]'); const on = !f.classList.contains('open'); f.classList.toggle('open', on); document.body.classList.toggle('lock', on && innerWidth <= 900); }));

  /* sticky add-to-cart (PDP, mobile) */
  const sticky = $('[data-sticky-atc]');
  if (sticky) {
    sticky.hidden = false;
    const form = sticky.closest('form'); const mainBtn = $('[data-submit]', form); const price = $('[data-price]', form); const sp = $('[data-sticky-price]', sticky); const sb = $('[data-sticky-submit]', sticky);
    let tick = false;
    const check = () => { tick = false; const r = mainBtn.getBoundingClientRect(); sticky.classList.toggle('on', r.bottom < 0 || r.top > innerHeight); };
    addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
    addEventListener('resize', check); check();
    new MutationObserver(() => { sp.textContent = price.textContent; sb.disabled = mainBtn.disabled; sb.textContent = mainBtn.textContent; }).observe(price, { childList: true, characterData: true, subtree: true });
    sb.addEventListener('click', e => { e.preventDefault(); form.requestSubmit(); });
  }
  /* rails: drag-to-scroll + arrows */
  $$('.rail').forEach(rail => {
    let down = false, moved = false, startX = 0, startL = 0, pid = null;
    rail.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = true; moved = false; startX = e.clientX; startL = rail.scrollLeft; pid = e.pointerId; });
    rail.addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - startX; if (!moved && Math.abs(dx) > 4) { moved = true; rail.classList.add('dragging'); rail.setPointerCapture(pid); } if (moved) rail.scrollLeft = startL - dx; });
    const up = () => { if (!down) return; down = false; if (moved) { setTimeout(() => rail.classList.remove('dragging'), 0); } };
    rail.addEventListener('pointerup', up); rail.addEventListener('pointercancel', up); rail.addEventListener('mouseleave', up);
    rail.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    const nav = rail.parentElement.querySelector('[data-rail-nav]');
    if (nav) {
      const prev = $('[data-rail-prev]', nav), next = $('[data-rail-next]', nav);
      const step = () => { const c = rail.querySelector('.card'); return c ? c.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8; };
      const sync = () => { prev.disabled = rail.scrollLeft <= 2; next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2; };
      prev.addEventListener('click', () => rail.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
      next.addEventListener('click', () => rail.scrollBy({ left: step() * 2, behavior: 'smooth' }));
      rail.addEventListener('scroll', sync, { passive: true }); addEventListener('resize', sync); sync();
    }
  });

  /* pairs well with — complementary fallback */
  $$('[data-pairs-fetch]').forEach(async box => {
    try {
      const r = await fetch(box.dataset.pairsFetch, { headers: { Accept: 'application/json' } }); const d = await r.json();
      const ps = (d.products || []).filter(p => p.available).slice(0, 3);
      if (!ps.length) { box.hidden = true; return; }
      $('.pair-list', box).innerHTML = ps.map(p => `<div class="pair"><a class="pim" href="${p.url}">${p.featured_image ? `<img src="${p.featured_image}&width=160" alt="" loading="lazy" width="80" height="80">` : ''}</a><div class="pt"><a href="${p.url}">${p.title}</a><span>${money(p.price)}</span></div>${p.variants.length === 1 ? `<button type="button" class="padd" data-add="${p.variants[0].id}">+ Add</button>` : `<a class="padd" href="${p.url}">View</a>`}</div>`).join('');
    } catch (e) { box.hidden = true; }
  });

  /* sort */
  $$('[data-sort]').forEach(s => s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u; }));

  /* facets: a filter change reloads the page, which used to re-collapse every group the
     shopper had opened and throw them back to the top. Remember both across the reload. */
  (() => {
    const form = document.getElementById('facets');
    if (!form) return;
    const base = 'dp:facets:' + location.pathname;
    const OPEN = base + ':open', SCROLL = base + ':scroll';
    const groups = $$('details[data-facet]', form);
    const read = k => { try { return sessionStorage.getItem(k); } catch (e) { return null; } };
    const write = (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) {} };

    /* restore which groups were open (shopper's choice beats the template default) */
    let saved = null;
    try { saved = JSON.parse(read(OPEN) || 'null'); } catch (e) { saved = null; }
    if (saved) groups.forEach(d => { const v = saved[d.dataset.facet]; if (typeof v === 'boolean') d.open = v; });

    const remember = () => {
      const o = {};
      groups.forEach(d => { o[d.dataset.facet] = d.open; });
      write(OPEN, JSON.stringify(o));
    };
    groups.forEach(d => d.addEventListener('toggle', remember));

    /* restore scroll. form.submit() (the inline onchange) fires no submit event, so we
       hang the save off change too, and clear it immediately so a later visit starts fresh. */
    const y = read(SCROLL);
    if (y !== null) {
      try { sessionStorage.removeItem(SCROLL); } catch (e) {}
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      const to = parseInt(y, 10) || 0;
      /* The grid's images are lazy, so right after paint the document can still be too short
         for this offset and scrollTo would clamp to the top. Keep nudging for ~1s until the
         page is tall enough — and stand down the moment the shopper scrolls for themselves. */
      let stop = false, tries = 0;
      ['wheel', 'touchstart', 'keydown'].forEach(ev =>
        addEventListener(ev, () => { stop = true; }, { passive: true, once: true }));
      const settle = () => {
        if (stop || tries++ > 60) return;
        scrollTo(0, to);
        if (Math.abs(scrollY - to) > 2) requestAnimationFrame(settle);
      };
      requestAnimationFrame(settle);
      addEventListener('load', () => { if (!stop) scrollTo(0, to); });
    }
    /* capture phase: the checkbox's own inline onchange calls form.submit(), which starts
       navigating before a bubble-phase listener would ever run. Capture beats it to the punch. */
    const park = () => { remember(); write(SCROLL, String(scrollY)); };
    form.addEventListener('change', park, true);
    form.addEventListener('submit', park, true);
  })();


  /* fit finder */
  $$('[data-fit]').forEach(box => {
    const data = JSON.parse($('[data-fit-data]', box).textContent);
    const sel = $('select', box); const out = $('[data-fit-out]', box);
    const noneMsg = out.dataset.none, noData = out.dataset.nodata;
    function render() {
      const h = sel.value; out.innerHTML = '';
      if (!h) { out.innerHTML = '<p class="msg">' + noneMsg + '</p>'; return; }
      const m = data[h];
      if (!m || !m.filters.length) { out.innerHTML = '<p class="msg">' + noData + '</p>'; return; }
      const pods = m.filters.map(f => `<div class="pod"><div class="im"><img src="${f.img}" alt="" loading="lazy"></div><b><a href="${f.url}">${f.title}</a></b><span>${[f.stage, f.interval ? 'every ' + f.interval + ' mo' : ''].filter(Boolean).join(' · ') || (m.connector || '')}</span><div class="pr">${f.available ? money(f.price) : 'Sold out'}</div></div>`).join('');
      const avail = m.filters.filter(f => f.available);
      const total = avail.reduce((s, f) => s + f.price, 0);
      out.innerHTML = `<div class="label eyebrow" style="margin-bottom:12px"><span class="lift">${m.connector ? m.connector + ' · ' : ''}${m.filters.length} filters fit the ${m.title}</span></div><div class="pods">${pods}</div>` +
        (avail.length > 1 ? `<div class="set"><button class="btn elec" data-add="${avail.map(f => f.variant).join(',')}">Add the full set</button><span class="tot">${avail.length} items · <b>${money(total)}</b></span></div>` : '');
    }
    sel.addEventListener('change', render);
    const pre = new URLSearchParams(location.search).get('model'); if (pre && data[pre]) sel.value = pre;
    render();
  });
})();



